import axios from 'axios'
import { partnerDisplay } from '@utils/appConstants'
import { getSavedState, saveState } from '@state/helpers'
import _ from 'lodash'

export const state = {
  referrerData: getSavedState('referrer.referrerData'),
  products: getSavedState('referrer.products'),
}

export const getters = {
  referrerData: (state) => state.referrerData,
}

export const mutations = {
  SET_REFERRER_DATA(state, newValue) {
    state.referrerData = newValue
    saveState('referrer.referrerData', newValue)
  },
  SET_PRODUCTS(state, newValue) {
    state.products = newValue
    saveState('referrer.products', newValue)
  },
}

export const actions = {
  getData({ commit, state }, siteID = 0) {
    let partnerData

    return axios
      .get('/consumer-api/partner/v1/site-id/' + siteID)
      .then((response) => {
        const partnerID = _.get(response, 'data.uid', '0')
        if (_.some(partnerDisplay, { id: partnerID })) {
          partnerData = _.find(partnerDisplay, { id: partnerID })
        } else {
          // If no partner data match, default to 0
          partnerData = _.find(partnerDisplay, { id: '0' })
          partnerData.id = partnerID
        }
        partnerData.siteID = siteID

        partnerData.voucherEnabled = response.data.enablePromoCode
        // Set default header to send attach to all requests
        commit('SET_REFERRER_DATA', partnerData)

        return partnerID
      })
      .catch((error) => {
        if (error) {
          partnerData = _.find(partnerDisplay, { id: '0' })

          commit('SET_REFERRER_DATA', partnerData)
          // ACATB-5384 site id not always captured; default to organic
          if (partnerData !== undefined) {
            partnerData.siteID = '0'
          }
        }
        return '0'
      })
  },
  getProducts({ commit, state }) {
    return axios
      .get('/consumer-api/product/v1/partner')
      .then((response) => {
        commit('SET_PRODUCTS', response.data)
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          commit('SET_PRODUCTS', [])
        }
        return null
      })
  },
}
